import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { KioskService } from "src/app/core/services/kiosk.service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-kiosk-order-active",
	templateUrl: "./kiosk-order-active.component.html",
	styleUrls: ["../../kiosk.styles.scss"],
})
export class KioskOrderActiveComponent implements OnInit, OnDestroy {
	@Input() selectViewOrder: boolean;
	@Output() selectViewOrderChange = new EventEmitter<boolean>();

	@Input() startCheckout: boolean;
	@Output() startCheckoutChange = new EventEmitter<boolean>();

	itemFunctionButtonOptions = [
		{
			value: "remove",
			faPrefix: "fad",
			faIcon: "minus",
		},
		{
			value: "edit",
			faPrefix: "fad",
			faIcon: "pencil",
		},

		{
			value: "reorder",
			faPrefix: "fad",
			faIcon: "plus",
		},
	];

	constructor(public kioskService: KioskService) {}
	ngOnDestroy(): void {}

	ngOnInit(): void {
		this.kioskService.activeOrder.subscribe((order) => {
			if (order.seats[0].items.length === 0) {
				this.selectViewOrderChange.emit(false);
			}
		});
	}

	itemFunctionCommand(event, parentIndex: number, modifierIndex?: number) {
		console.log(event);
		switch (event.option.value) {
			case "reorder": {
				this.kioskService.kioskOrderAddItem({ ...this.kioskService.activeOrder.value.seats[0].items[parentIndex] });
				break;
			}
			case "edit": {
				throw new Error("Method not implemented.");
				break;
			}
			case "remove": {
				const itemName = this.kioskService.activeOrder.value.seats[0].items[parentIndex].name;
				this.kioskService.kioskOrderRemoveItem(parentIndex);
				this.kioskService.app.msgSvc.add({ severity: AppMessageSeverity.BLUE, summary: "", detail: `${itemName} has been removed from your order.` });
				break;
			}
		}
	}
}
